@if (authRules$ | async; as authRules) {
  <button
    *ngIf="(authRules$ | async)?.length > 0"
    mat-stroked-button
    [matMenuTriggerFor]="portalMenu"
    class="mr-2"
  >
    <mat-icon>public</mat-icon>
    {{ 'patient-details.appointment.portals-menu-button' | translate }}
  </button>
  <mat-menu #portalMenu="matMenu">
    <ng-container *ngFor="let rule of (authRules$ | async)">
      <a
        mat-menu-item
        [attr.href]="rule.systemPortal?.url"
        target="_blank"
        rel="noreferrer"
      >
        [{{ rule.insurance.clinicCarrierName }}] {{ rule.systemPortal?.name }}
      </a>
    </ng-container>
  </mat-menu>
}
